// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__TyOHn","inner":"Footer_inner__3LJiv"};